import { PropsWithChildren } from "react";

type Props = {
  className?: string;
};

export const Title = ({ children }: PropsWithChildren<Props>) => {
  return <h2 className="text-center font-semibold text-white">{children}</h2>;
};
